import { initialsOf, type PresenceMember } from "@livcg/schema";
import { Eye, EyeOff } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "../../ui/index.js";

const VIEW_LABEL: Record<string, string> = {
  efir: "Efir",
  control: "Control",
  deck: "Deck",
  classic: "Klassik",
};

function ago(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  return s < 60 ? `${s} s oldin` : `${Math.floor(s / 60)} daq oldin`;
}

export function PresenceAvatars({
  members,
  selfId,
  cursorsHidden,
  onToggleCursors,
}: {
  members: PresenceMember[];
  selfId: string | null;
  cursorsHidden: boolean;
  onToggleCursors: () => void;
}) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 5000);
    return () => clearInterval(t);
  }, []);
  if (members.length === 0) return null;
  return (
    <div className="flex items-center gap-1.5">
      <div className="flex -space-x-1.5">
        {members.map((m) => (
          <span
            key={m.id}
            title={`${m.username}${m.id === selfId ? " (siz)" : ""} — ${VIEW_LABEL[m.view] ?? m.view} · faol ${ago(now - m.lastActiveAt)}`}
            className="grid h-7 w-7 place-items-center rounded-full border-2 border-canvas text-[10px] font-bold text-white"
            style={{ backgroundColor: m.color }}
          >
            {initialsOf(m.username)}
          </span>
        ))}
      </div>
      <Button
        variant="ghost"
        size="xs"
        iconOnly
        aria-label={cursorsHidden ? "Kursorlarni ko'rsatish" : "Kursorlarni yashirish"}
        title={cursorsHidden ? "Kursorlarni ko'rsatish" : "Kursorlarni yashirish"}
        onClick={onToggleCursors}
      >
        {cursorsHidden ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
      </Button>
    </div>
  );
}
